module.exports = __webpack_public_path__ + "img/logo_vslbooster_icon.d7f50360.png";